import { KnownMembership, MatrixClient, RoomMember } from 'matrix-js-sdk/src/matrix';

import { isEmailFormat } from 'modules/CreateWorkspaceModal/WorkspaceInviteStep/WorkspaceInviteForm/utils';
import { isSystemUser } from 'utils/matrixUtils';

type GetRoomMembersParams = {
  matrixClient: MatrixClient;
  roomId: string;
};

export const getJoinedMembers = ({ matrixClient, roomId }: GetRoomMembersParams): RoomMember[] => {
  const room = matrixClient.getRoom(roomId);
  if (!room) return [];

  const roomMembers = room.getJoinedMembers();
  const currentUserId = matrixClient.getUserId();

  return roomMembers.filter((member) => member.userId !== currentUserId && !isSystemUser(member.userId));
};

export const filterInviteesToWorkspaceMembers = (
  matrixClient: MatrixClient,
  workspaceId: string,
  invitees: string[]
): string[] => {
  const workspaceRoom = matrixClient.getRoom(workspaceId);
  if (!workspaceRoom) {
    return invitees.filter((invitee) => !isEmailFormat(invitee));
  }

  const joinedMemberIds = new Set(
    workspaceRoom
      .getMembers()
      .filter((member) => member.membership === KnownMembership.Join)
      .map((member) => member.userId)
  );

  return invitees.filter((invitee) => !isEmailFormat(invitee) && joinedMemberIds.has(invitee));
};
